<!-- Screenname:Generic Master Filter
Developer Name:Bharanidharan.
Created date on:14/02/2023
Last Working date on:23/02/2023
Comments and Suggestions:
TS File:GenericMasterService -->


<template>
  <n-drawer :width="350" class="right-filter">
    <n-drawer-content title="Stoner" closable>
      <b-tabs pills card vertical>
        <b-tab active>
          <template #title>
            <n-icon>
              <img class="filter-icons" src="../../../../../../assets/Img/icons/filter.svg" />
            </n-icon>
          </template>
          <h6 class="filter-heading">Filter</h6>
          <div class="">
            <b-row>
              <b-col>
                <div class="field">
                  <label for="gname">Generic Name</label>
                  <InputText id="gname" type="text" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="field">
                  <label for="state">Status</label>
                  <Dropdown id="state" v-model="dropdownItem" :options="dropdownItems" optionLabel="name"
                    placeholder="">
                  </Dropdown>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="d-flex flex-row-reverse">
                  <b-button class="ms-2 p-button-info p-button-sm">Filter</b-button>
                  <b-button class="p-button-secondary p-button-sm">Cancel</b-button>
                </div>
              </b-col>
            </b-row>
          </div>


          <!-- <n-form class="mt-4">
                <n-form-item label="Generic Name" path="user.name">
                  <n-input placeholder="Input Name" />
                  </n-form-item>
                            <n-form-item label="Status" path="user.name">
                              <n-select  :options="options" />
                            </n-form-item>
                            <div class="d-flex flex-row-reverse">
                              <b-button variant="primary" class="ms-2">Filter</b-button>
                              <b-button variant="secondary">Cancel</b-button>
                            </div>
                        </n-form> -->
        </b-tab>
        <b-tab>
          <template #title>
            <n-icon>
              <img class="filter-icons" src="../../../../../../assets/Img/icons/group-filed.svg" />
            </n-icon>
          </template>
          <h6 class="filter-heading">Group Fields</h6>
          <n-form class="mt-4">
            <n-checkbox-group>
              <n-space vertical>
                <n-checkbox value="Option 1">
                  Generic Id
                </n-checkbox>
                <n-checkbox value="Option 2">
                  Generic Name
                </n-checkbox>
                <n-checkbox value="Option 3">
                  Items
                </n-checkbox>
                <n-checkbox value="Option 4">
                  Actions
                </n-checkbox>
              </n-space>
            </n-checkbox-group>
          </n-form>
        </b-tab>
        <b-tab>
          <template #title>
            <n-icon>
              <img class="filter-icons" src="../../../../../../assets/Img/icons/show-hide.svg" />
            </n-icon>
          </template>
          <h6 class="filter-heading">Filter Columns</h6>
          <n-form class="mt-4">
            <n-checkbox-group>
              <n-space vertical>
                <n-checkbox value="Option 1">
                  Generic Id
                </n-checkbox>
                <n-checkbox value="Option 2">
                  Generic Name
                </n-checkbox>
                <n-checkbox value="Option 3">
                  Items
                </n-checkbox>
                <n-checkbox value="Option 4">
                  Actions
                </n-checkbox>
              </n-space>
            </n-checkbox-group>
          </n-form>
        </b-tab>
        <b-tab>
          <template #title>
            <n-icon>
              <img class="filter-icons" src="../../../../../../assets/Img/icons/download.svg" />
            </n-icon>
          </template>
          <h6 class="filter-heading">Download Options</h6>
          <n-form class="mt-4">
            <n-button>Download </n-button>
          </n-form>
        </b-tab>
      </b-tabs>
    </n-drawer-content>
  </n-drawer>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  components: {


  },
  setup() {
    const dropdownItems = ref([
      { name: 'Active', code: 'Option 1' },
      { name: 'In-Active', code: 'Option 2' },
    ]);

    const dropdownItem = ref(null);
    return {
      dropdownItem,
      dropdownItems,
      showgenericright: ref(false),
      //   options: [
      //   {
      //     label: "Active",
      //     value: 'active',
      //   },
      //   {
      //     label: 'In-Active',
      //     value: 'inactive'
      //   },
      // ]
    }
  }
})
</script>

<style scoped>
.right-filter .filter-heading {
  font-size: 18px;
  color: #444444;
  font-weight: 600;
  margin-top: 15px;
}

.right-filter .tab-content {
  padding: 0px 15px;
  width: 100%;
}

.right-filter .card-header .me-3 {
  margin-right: 0rem !important;
}

.right-filter .nav-pills .nav-link.active {
  background-color: #e1e1e1;
  border-radius: 0px;
}

.right-filter .card-header {
  border-right: 1px solid #e1e1e1;
  height: 100vh;
  background-color: azure !important;
}
</style>